export const GET_ACTIVE_QD_MODELS_SUCCESS = 'GET_ACTIVE_QD_MODELS_SUCCESS';
export const GET_ACTIVE_QD_MODELS_FAIL = 'GET_ACTIVE_QD_MODELS_FAIL';

export const GET_EVALUATED_QD_MODELS_SUCCESS = 'GET_EVALUATED_QD_MODELS_SUCCESS';
export const GET_EVALUATED_QD_MODELS_FAIL = 'GET_EVALUATED_QD_MODELS_FAIL';

export const GET_LOAN_APPLICATION_HISTORY_SUCCESS = 'GET_LOAN_APPLICATION_HISTORY_SUCCESS';
export const GET_LOAN_APPLICATION_HISTORY_FAIL = 'GET_LOAN_APPLICATION_HISTORY_FAIL';
